<div style="padding: 24px">
  <div style="  display: grid;overflow-wrap: anywhere;
  grid-template-columns: repeat(3, 1fr); /* 3 columns with equal width */
  gap: 10px;">

    @for (config of configs; track config; let i = $index; ) {
      <div [attr.data-testid]="config.key" class="card">
        <div class="card-header">{{ config.key }}</div>

        <div class="card-body">
          <div style="display: flex;justify-content: space-between;padding-top: 16px">
            <div class="title-medium">{{ config.value.asString() }}</div>
          </div>
        </div>
      </div>
    }
  </div>
</div>




